// extracted by mini-css-extract-plugin
export default {"container":"styles_container__VDD5s","logout":"styles_logout__qY7Z3"};